<h2 mat-dialog-title>{{ data?.title || 'Dialog' }}</h2>
<mat-dialog-content>
  <app-inquiry></app-inquiry>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngFor="let action of data?.actions" mat-button (click)="onAction(action)">
    {{ action.label }}
  </button>
</mat-dialog-actions>
